import * as React from "react";

import Stack from '@mui/material/Stack';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import IncompleteIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import FailIcon from '@mui/icons-material/Cancel';
import WarningIcon from '@mui/icons-material/SmsFailed';
import PassIcon from '@mui/icons-material/Visibility';
import {List, ListItem, ListItemText, PaletteColor, Typography, useTheme} from "@mui/material";

import {AllStates, Level, StepForm} from "./Forms";

import {useTranslate} from "@tolgee/react";

import FromMarkdown, {translate} from "./Representation";

export const INCOMPLETE_COLOR: PaletteColor = {
    main: '#9e9e9e',
    dark: '#6e6e6e',
    light: '#b1b1b1',
    contrastText: '#ffffff'
};

interface DashboardProps {
    allStates: AllStates,
    stepForms: StepForm[]
}

function Dashboard(
    {
        allStates,
        stepForms
    }: DashboardProps) {

    const theme = useTheme();

    const {t} = useTranslate();

    const cardFor = (step: number) => {
        const stepForm = stepForms[step];
        const [formData, _] = allStates.ordered[step];
        const titleKey = stepForm.getTitleKey();
        const status = stepForm.getStatus(formData, allStates, false, t);

        let subtitleKey;
        let color = theme.palette.primary;
        let icon = <React.Fragment/>;

        if (status.level === Level.INCOMPLETE) {
            subtitleKey = "status_incomplete";
            color = INCOMPLETE_COLOR;
            icon = <IncompleteIcon color="inherit"/>;
        } else if (status.level === Level.VALIDATION_FAILED) {
            subtitleKey = "status_invalid";
            color = theme.palette.error;
            icon = <FailIcon/>;
        } else if (status.level === Level.CONTEXT_FAILED) {
            subtitleKey = "status_insufficient";
            color = theme.palette.warning;
            icon = <WarningIcon/>;
        } else if (status.level === Level.OK) {
            subtitleKey = "status_ok";
            color = theme.palette.info;
            icon = <PassIcon/>;
        } else {
        }

        return <Card variant="outlined" key={"step" + step}>
            <CardHeader title={<Typography color={color.contrastText}>{t(titleKey)}</Typography>}
                        subheader={<Typography variant='body2'
                                               color={color.contrastText}>{subtitleKey !== undefined ? t(subtitleKey) : ""}</Typography>}
                        sx={{
                            bgcolor: color.main,
                            color: color.contrastText,
                            p: 1
                        }}
                        disableTypography
                        avatar={<Typography gutterBottom={false} component="span"
                                            color={color.contrastText}>{icon}</Typography>}/>
            <CardContent sx={{paddingBottom: 0, paddingTop: 0}} style={{maxHeight: 100, overflow: 'auto'}}>
                <List dense={true}>
                    {status.messages.map((message) => {
                        return <ListItem key={!message ? "" : typeof message === "string" ? message : message.key}>
                            <ListItemText
                                primary={
                                    <FromMarkdown>{message === undefined ? "" : translate(message, t)}</FromMarkdown>
                                }
                            />
                        </ListItem>;
                    })}
                </List>
            </CardContent>
        </Card>
    }

    return (
        <Stack spacing={2}>
            {stepForms.map((_stepForm, index) => {
                return cardFor(index);
            })}
        </Stack>
    );
}

export default Dashboard;